export default __webpack_public_path__ + "static/media/Astronaut-05.8f4df4fd.png";